// Visual tokens lifted verbatim from the Riffle deck so every page reads as
// one art-directed set. Nothing here is new — it is the section's own values,
// pulled out so the navbar, footer, and standing pages share them.

export const PERSP = 1400
export const SPRING = 0.2
export const PARALLAX_EASE = 0.06
export const PARALLAX_RANGE = 5 // ±2.5° once halved around centre

export const CARD_SHADOW =
    '0 2px 5px rgba(0,0,0,0.45), 0 30px 60px -16px rgba(0,0,0,0.66), inset 0 1px 0 rgba(255,255,255,0.14), inset 0 -1.5px 2px rgba(0,0,0,0.34), inset 0 0 0 1px rgba(255,255,255,0.05)'

// Studio cove — the same two lights that wrap the deck.
export const COVE_KEY =
    'radial-gradient(ellipse 80% 50% at 50% -12%, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0) 58%)'
export const COVE_FLOOR =
    'radial-gradient(ellipse 62% 130% at 50% 138%, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 66%)'
export const VIGNETTE =
    'radial-gradient(ellipse 92% 82% at 50% 50%, rgba(0,0,0,0) 56%, rgba(0,0,0,0.28) 100%)'
export const SHEEN =
    'linear-gradient(105deg, transparent 34%, rgba(255,255,255,0.5) 50%, transparent 66%)'

// Hairlines and text weights used across the section.
export const HAIRLINE = 'rgba(255,255,255,0.1)'
export const HAIRLINE_SOFT = 'rgba(255,255,255,0.06)'
export const INK_STRONG = 'rgba(255,255,255,0.95)'
export const INK_BODY = 'rgba(255,255,255,0.8)'
export const INK_MUTED = 'rgba(255,255,255,0.55)'
export const INK_FAINT = 'rgba(255,255,255,0.42)'
export const INK_ERROR = 'rgba(232,122,122,0.92)'

// The confirmed-state green from the detail view's Order button.
export const CONFIRM_BG = 'rgba(152,212,162,0.97)'
